import {
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_FAILURE,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_REQUEST,
  RETRIEVE_OUTBOUND_POSTAL_OPERATOR_SUCCESS,
  DEPARTURE_MAIL_PROCESSING_CENTER_CHECKED,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED,
  SELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS,
  DESELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS,
  SELECT_ALL_DEPARTURE_OPERATORS,
  DESELECT_ALL_DEPARTURE_OPERATORS,
  DEPARTURE_OPERATOR_CENTER_CHECKED,
  DEPARTURE_POSTAL_OPERATOR_EXPANDED_ADMIN,
} from './types/DeparturePostalOperatorActionTypes';

export function retrieveOutboundPostalOperatorsRequestActionCreator(
  payload,
  reportDefinition,
  departureCheckedMailProcessingCenters,
) {
  return {
    type: RETRIEVE_OUTBOUND_POSTAL_OPERATOR_REQUEST,
    payload,
    reportDefinition,
    departureCheckedMailProcessingCenters,
  };
}

export function retrieveOutboundPostalOperatorsSuccessActionCreator(payload) {
  return {
    type: RETRIEVE_OUTBOUND_POSTAL_OPERATOR_SUCCESS,
    payload,
  };
}

export function retrieveOutboundPostalOperatorsFailureActionCreator(error) {
  return {
    type: RETRIEVE_OUTBOUND_POSTAL_OPERATOR_FAILURE,
    error,
  };
}

export function departureMailProcessingCenterCheckedActionCreator(
  checkedMailProcessingCenters,
  reportDefinition,
) {
  return {
    type: DEPARTURE_MAIL_PROCESSING_CENTER_CHECKED,
    checkedMailProcessingCenters,
    reportDefinition,
  };
}

export function departureOperatorCheckedActionCreator(
  checkedMailProcessingCenters,
  reportDefinition,
) {
  return {
    type: DEPARTURE_OPERATOR_CENTER_CHECKED,
    checkedMailProcessingCenters,
    reportDefinition,
  };
}

export function onDeparturePostalOperatorExpanded(expandedPostalOperators) {
  return {
    type: DEPARTURE_POSTAL_OPERATOR_EXPANDED,
    expandedPostalOperators,
  };
}

export function onDeparturePostalOperatorExpandedAdmin(expandedPostalOperatorsOperatorImpcAdmin) {
  return {
    type: DEPARTURE_POSTAL_OPERATOR_EXPANDED_ADMIN,
    expandedPostalOperatorsOperatorImpcAdmin,
  };
}

export function onSelectAllDepartureMailProcessingCenters(nodes) {
  return {
    type: SELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS,
    payload: {
      nodes,
    },
  };
}

export function onSelectAllDepartureOperators(nodes) {
  return {
    type: SELECT_ALL_DEPARTURE_OPERATORS,
    payload: {
      nodes,
    },
  };
}

export function onDeSelectAllDepartureMailProcessingCenters() {
  return {
    type: DESELECT_ALL_DEPARTURE_MAIL_PROCESSING_CENTERS,
  };
}

export function onDeSelectAllDepartureOperators() {
  return {
    type: DESELECT_ALL_DEPARTURE_OPERATORS,
  };
}

